import type { ExtractContractResponse } from '@vy/api-definition';
import { ExtractContractResponseSchema } from '@vy/api-definition';
import type { VyBaseError } from '@vy/err';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type ExtractContractAsyncInput = {
  files: File[];
};

export function useExtractContractAsync(
  options?: UseMutationOptions<ExtractContractResponse, VyBaseError, ExtractContractAsyncInput>,
) {
  return useMutation(async ({ files }) => {
    const api = getPrivateApi();
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await api.extractContract({ body: formData });

    return ExtractContractResponseSchema.parse(response);
  }, options);
}
